import { useState, useEffect } from 'react';
import { subscribeToBadgeModal, closeBadge } from '../services/badgeModalService';
import { Badge } from '../types/index';

export function useBadgeModal() {
  const [state, setState] = useState<{ isOpen: boolean; currentBadge: Badge | null }>({ 
    isOpen: false, 
    currentBadge: null 
  });

  useEffect(() => {
    return subscribeToBadgeModal(setState);
  }, []);

  return {
    isOpen: state.isOpen,
    currentBadge: state.currentBadge,
    onClose: closeBadge,
  };
}
